import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SidebarContent } from './Sidebar';
import { cfgLight, cfgDark } from '../theme';

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [SidebarContent, cfgLight, cfgDark],
});
